/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_NetworkInputs */

const en_error_network = /** @type {(inputs: Error_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Network error. Check your connection.`)
};

const es_error_network = /** @type {(inputs: Error_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error de red. Comprueba tu conexión.`)
};

const fr_error_network = /** @type {(inputs: Error_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur réseau. Vérifiez votre connexion.`)
};

const de_error_network = /** @type {(inputs: Error_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Netzwerkfehler. Überprüfe deine Verbindung.`)
};

const ja_error_network = /** @type {(inputs: Error_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネットワークエラーです。接続を確認してください。`)
};

const zh_error_network = /** @type {(inputs: Error_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`网络错误。请检查您的连接。`)
};

const ar_error_network = /** @type {(inputs: Error_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطأ في الشبكة. تحقق من اتصالك.`)
};

const id_error_network = /** @type {(inputs: Error_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kesalahan jaringan. Periksa koneksi Anda.`)
};

const it_error_network = /** @type {(inputs: Error_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore di rete. Controlla la tua connessione.`)
};

const ru_error_network = /** @type {(inputs: Error_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка сети. Проверьте подключение.`)
};

const pt_error_network = /** @type {(inputs: Error_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro de rede. Verifique sua conexão.`)
};

const ko_error_network = /** @type {(inputs: Error_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네트워크 오류입니다. 연결을 확인해 주세요.`)
};

/**
* | output |
* | --- |
* | "Network error. Check your connection." |
*
* @param {Error_NetworkInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_network = /** @type {((inputs?: Error_NetworkInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_NetworkInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_network(inputs)
	if (locale === "es") return es_error_network(inputs)
	if (locale === "fr") return fr_error_network(inputs)
	if (locale === "de") return de_error_network(inputs)
	if (locale === "ja") return ja_error_network(inputs)
	if (locale === "zh") return zh_error_network(inputs)
	if (locale === "ar") return ar_error_network(inputs)
	if (locale === "id") return id_error_network(inputs)
	if (locale === "it") return it_error_network(inputs)
	if (locale === "ru") return ru_error_network(inputs)
	if (locale === "pt") return pt_error_network(inputs)
	return ko_error_network(inputs)
});